export default __webpack_public_path__ + "static/media/Flag of Pitcairn Islands.a0e8f946.gif";